import { render } from "./EventShow.vue?vue&type=template&id=343a7e54"
import script from "./EventShow.vue?vue&type=script&lang=js"
export * from "./EventShow.vue?vue&type=script&lang=js"

import "./EventShow.vue?vue&type=style&index=0&id=343a7e54&lang=scss"
script.render = render

export default script